import Box from '@mui/material/Box'
import {
  Button,
  Grid,
  TextField,
} from '@mui/material'
import * as React from 'react'
import { useFormik } from 'formik'
import jwt_decode from 'jwt-decode'
import LoadingSection from '../../../common/components/loaders/loader'
import { useLocation, useSearchParams } from 'react-router-dom'
import {
  normalizeApiResponse,
  requiredLabel,
} from '../../../helpers/HelperFunctions'
import { useToastContext } from '../../../App'

import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { FileEditFormValidation, FileUploadFormValidation }
  from '../../../validations/FileUploadValidation'
import { editFileDoc, uploadFileDoc } from '../../../api/orders/directRoutingAPI'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function InputFileUpload(props) {
  return (
    <Button
      component="label"
      role={undefined}
      variant="outlined"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
    >
      Upload files
      <VisuallyHiddenInput
        type="file"
        onChange={(event) => props.onFileChange(event.target.files, 'file')}
      />
    </Button>
  );
}



export function AddNewDoc(props) {
  const { toast } = useToastContext()
  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [searchParams] = useSearchParams()
  const location = useLocation();
  const [base64File, setBase64File] = React.useState("");
  const [fileName, setFileName] = React.useState("");

  const formik = useFormik({
    initialValues: {
      "FileImage": props?.details ? props?.details?.FileImage : "",
      "FileName": props?.details ? props?.details?.FileName : "",
      "FileType": "NOT_SPECIFIED",
      "Description": props?.details ? props?.details?.Description : "",
      "CustomerId": 0
    },
    validationSchema: props?.action == 'edit' ? FileEditFormValidation : FileUploadFormValidation,
    onSubmit: async (data) => {
      let fileNameSplit = fileName?.split('.')
      const fileExt = fileName?.split('.')[fileNameSplit.length - 1]
      const decodeToken = localStorage.getItem('sd_cp.jwt:tkn');
      const decoded = jwt_decode(decodeToken);

      const companyId = searchParams.get('company_id') || decoded?.company_id;
      data.FileImage = base64File
      data.FileType = "NOT_SPECIFIED"
      data.FileName = data.FileName + "." + fileExt;
      if (props?.action == 'edit') data.FileId = props?.details?.FileId;

      try {
        setSubmitLoader(true);
        let action = props?.action == 'edit' ? editFileDoc : uploadFileDoc
        let actionMsg = props?.action == 'edit' ? "File updated successfully" : "File added successfully"
        const response = await action({ companyId: companyId },
          { companyId: companyId, CustomerId: companyId }, companyId, data,
        );
        toast.showToast(actionMsg, 'success');
        props?.toggleDrawer('right', true);
        props.toggleDrawer('right', false, '', '', true);
      } catch (error) {
        toast.showToast(normalizeApiResponse(error)?.message, 'error');
      } finally {
        setSubmitLoader(false);
      }
    },
  });


  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const onFileChange = async (file) => {

    if (!file[0]) return;

    // convert to base64
    const base64 = await fileToBase64(file[0]);

    setFileName(file[0]?.name);
    
    let base64String = base64.split(",")[1];
    formik.setFieldValue("FileImage", base64String);

    setBase64File(base64String);
  }
  return <>
    {submitLoader ? <LoadingSection></LoadingSection> : ''}
    <Box role="presentation">
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          padding: '5px 10px 90px 20px',
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Grid container columnSpacing={4} rowSpacing={3}>
            <Grid item md={12} sm={12} xs={6}>
              {requiredLabel("File")}

              <InputFileUpload onFileChange={onFileChange} />
              {fileName && <i style={{ display: "block" }}>{fileName}</i>}

              {formik.errors.FileImage && (
                <div style={{ color: "red", marginTop: "5px" }}>
                  {formik.errors.FileImage}
                </div>
              )}
            </Grid>

            <Grid item md={12} sm={12} xs={6}>
              {requiredLabel('File Name')}
              <TextField
                id="fileName"
                name="FileName"
                onChange={formik.handleChange}
                value={formik.values.FileName}
                fullWidth
                InputProps={{
                  style: {
                    height: '35px',
                  },
                }}
              />
              <div
                style={{
                  color: 'red',
                  position: 'absolute',
                  marginBottom: '5px',
                }}
              >
                {formik.errors.FileName && formik.errors.FileName}
              </div>
            </Grid>

            <Grid item md={12} sm={12} xs={6}>
              {requiredLabel('Description')}
              <TextField
                id="Description"
                name="Description"
                onChange={formik.handleChange}
                value={formik.values.Description}
                fullWidth
                InputProps={{
                  style: {
                    height: '35px',
                  },
                }}
              />
              <div
                style={{
                  color: 'red',
                  position: 'absolute',
                  marginBottom: '5px',
                }}
              >
              </div>
            </Grid>


          </Grid>
          <Box
            style={{
              position: 'fixed',
              marginTop: '40px',
              background: 'white',
              display: 'flex',
            }}
          >
            <Button
              disabled={!(formik.isValid && formik.dirty)}
              type="submit"
              variant="contained"
              color="primary"
              size="large"
            >
              Save
            </Button>
            <div style={{ marginLeft: '20px' }}>
              <Button
                variant="outlined"
                onClick={() =>
                  props.toggleDrawer('right', false, '', '', false)
                }
                disableElevation
                size="large"
              >
                Cancel
              </Button>
            </div>
          </Box>
        </form>
      </div>
    </Box>
  </>;
}

export default AddNewDoc
